import { render, staticRenderFns } from "./repeatesentence.vue?vue&type=template&id=788f3a48&scoped=true&"
import script from "./repeatesentence.vue?vue&type=script&lang=js&"
export * from "./repeatesentence.vue?vue&type=script&lang=js&"
import style0 from "./repeatesentence.vue?vue&type=style&index=0&id=788f3a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f3a48",
  null
  
)

export default component.exports